import { Constants } from "./constants.util";

export class RoleUtil {
    public static isClientAdministrator(roles: string[]): boolean {
        return roles && roles.some(s => s == Constants.ClientAdministrator);
    }

    public static isCoachImpersonate(roles: string[]) : boolean {
        return roles && roles.some(s => s == Constants.CoachImpersonate);
    }

    public static isCorporationAdministrator(roles: string[]): boolean {
        return roles && roles.some(s => s == Constants.CorporationAdministrator);
    }

    public static isHuronAdmin(roles: string[]): boolean {
        return roles && roles.some(s => s == Constants.HuronAdministrator);
    }

    public static isHuronEmployee(roles: string[]): boolean {
        return this.isHuronAdmin(roles) || this.isHuronSupport(roles) || this.isCoachImpersonate(roles) || this.isCorporationAdministrator(roles);
    }

    public static isHuronSupport(roles: string[]): boolean {
        return roles && roles.some(s => s == Constants.HuronSupport);
    }
}